export default {
  'moduleTitle.address': 'Adresa',
  'moduleTitle.address_details': 'Detail adresy',
  'moduleTitle.activity_details': 'Detail aktivity',
  'moduleTitle.add_log': 'Přidat záznam',
  'moduleTitle.award_level': 'Úroveň',
  'moduleTitle.adventurous_journey': 'Dobrodružná expedice',
  'moduleTitle.already_assessed': 'Již ohodnoceno!',
  'moduleTitle.approved': 'Schváleno!',
  'moduleTitle.assessor_details': 'Detaily hodnotitele',
  'moduleTitle.authorising_contact_license_holder': 'Autorizační kontakt/Držitel licence',
  'moduleTitle.category_journey_details': 'Detaily expedice',
  'moduleTitle.complete_report': 'Dokončit report',
  'moduleTitle.completed_progress': 'Dokončeno',
  'moduleTitle.congratulation': 'Gratulace!',
  'moduleTitle.confirming_email_address': 'Potvrzování emailu',
  'moduleTitle.contact_details': 'Kontaktní údaje',
  'moduleTitle.edit_log': 'Editovat záznam',
  'moduleTitle.event_journey': ' {event} Expedice',
  'moduleTitle.forgotten_password': 'Zapomenuté heslo',
  'moduleTitle.great_you_are_almost_there': 'Skvělé, už jsi téměř hotov. Posledním krokem je platba za novou úroveň.',
  'moduleTitle.home_address': 'Adresa',
  'moduleTitle.journey_overview': 'Přehled expedice',
  'moduleTitle.log_detail': 'Detail záznamu',
  'moduleTitle.login': 'Přihlášení',
  'moduleTitle.new_activity': 'Nová aktivita',
  'moduleTitle.new_event_journey': 'Nová {event} expedice',
  'moduleTitle.new_residential_project': 'Nová akce s pobytem',
  'moduleTitle.notRegistred': 'Nejste registrováni?',
  'moduleTitle.nominated_award_leader_contact_details': 'Nominovaný vedoucí kontakt',
  'moduleTitle.nominated_award_leader': 'Nominovaný vedoucí',
  'moduleTitle.organisation_address': 'Adresa organizace',
  'moduleTitle.organisation_details': 'Detaily organizace',
  'moduleTitle.online_record_book_account': 'ORB účet',
  'moduleTitle.page_not_found': '404 - stránka nenalezena',
  'moduleTitle.personal_details': 'Osobní údaje',
  'moduleTitle.preparation_and_training': 'Příprava a trénink',
  'moduleTitle.profile_guardian_consent': 'Souhlas rodič/opatrovníka',
  'moduleTitle.profile_questions': 'Profilové otázky',
  'moduleTitle.registration_for_level': 'Registrace do další úrovně',
  'moduleTitle.residential_project': 'Akce s pobytem',
  'moduleTitle.residential_project_details': 'Detaily akce s pobytem',
  'moduleTitle.reset_password': 'Resetovat heslo',
  'moduleTitle.welcome_to_the_orb': 'Vítejte v ORB',
  'moduleTitle.we_have_sent_you_an_email': 'Poslali jsme vám email s aktivačním kódem',
  'moduleTitle.your_registration_is_complete': 'Vaše registrace je kompletní',
  'formTitle.activity_details': 'Detaily aktivity',
  'formTitle.assessor_details': 'Detaily hodnotitele',
  'formTitle.supervisors_details': 'Detaily školitele',
  'formTitle.preparation_and_training_activities': 'Příprava a tréninkové aktivity',
  'formTitle.added_preparation_activities': 'Přidaná příprava a tréninkové aktivity',
  'label.add_picture': 'Přidat obrázek',
  'label.address_first_line': 'Adresa',
  'label.address_second_line': 'Adresa 2 (libovolné)',
  'label.are_you_already_running_award': 'Plníš si už DofE?',
  'label.are_you_the_main_award_leader': 'Jste hlavním vedoucím nebo koordinátorem v rámci Místního centra?',
  'label.award_participant': 'Účastník DofE',
  'label.award_leader': 'Vedoucí',
  'label.birthdate': 'Datum narození',
  'label.category': 'Kategorie',
  'label.change_locale': 'Změnit lokalitu',
  'label.choose_project': 'Vybrat aktivitu',
  'label.city': 'Město',
  'label.choose_as_major_activity': 'Zvolit jako nejdelší aktivitu',
  'label.date': 'Datum',
  'label.date_of_birth': 'Datum narození',
  'label.description_of_progress': 'Popis tvého pokroku',
  'label.duration': 'Trvání (min)',
  'label.email': 'Email',
  'label.email_address': 'Emailová adresa',
  'label.email_again': 'Potvrdit email',
  'label.employment_status': 'Zaměstnání',
  'label.end_date': 'Konec',
  'label.enter_his_email': 'Vložit email',
  'label.entered_transaction_id': 'ID vaší transakce',
  'label.first_name': 'Jméno',
  'label.gender': 'Pohlaví',
  'label.goal': 'Cíl',
  'label.journey_activity': 'Aktivita expedice',
  'label.journey_objective': 'Cíl Expedice',
  'label.journey_observations': 'Pozorování expedice',
  'label.journey_type': 'Typ expedice',
  'label.last_name': 'Přijmení',
  'label.level': 'Úroveň',
  'label.location': 'Lokalita',
  'label.logout': 'Odhlášení',
  'label.major': 'Hlavní',
  'label.middle_name': 'Prostřední jméno',
  'label.mode_of_transport': 'Způsob přepravy',
  'label.my_award_leader': 'Můj vedoucí',
  'label.name': 'Název expedice',
  'label.nationality': 'Národnost',
  'label.no': 'Ne',
  'label.no_results': 'Žádné výsledky',
  'label.note': 'Poznámka',
  'label.note_for_assessor': 'Poznámka pro hodnotitele',
  'label.note_for_leader': 'Poznámka pro vedoucího',
  'label.optional': 'nepovinné',
  'label.organisation_name': 'Jméno organizace',
  'label.organisation_type': 'Typ organizace',
  'label.others': 'Další',
  'label.password': 'Heslo',
  'label.password_again': 'Opakovat heslo',
  'label.project_location': 'Lokalita projektu',
  'label.pay_online': 'Platit online',
  'label.pay_award_leader_or_unit': 'Zaplatit vedoucímu nebo místnímu centru',
  'label.payment_not_required': 'Platba není od účastníka vyžadována',
  'label.payment_type': 'Způsob platby',
  'label.phone': 'Telefon',
  'label.phone_number': 'Telefonní číslo',
  'label.phone_type': 'Typ telefonu',
  'label.profile': 'Profil',
  'label.reset_password': 'Resetovat heslo',
  'label.region': 'Stát/provincie/region',
  'label.relationship': 'Vztah',
  'label.role_in_organisation': 'Role v organizaci',
  'label.select_country': 'Vyberte zemi',
  'label.select_your_au': 'Vybrat své místní centrum',
  'label.start_typing': 'začít psát',
  'label.start_date': 'Začátek',
  'label.select': 'Vybrat',
  'label.select_async': 'Začít psát',
  'label.select_your_operating_authority': 'Vybrat vaši autoritu',
  'label.specify_category': 'Prosím specifikujte svou kategorii',
  'label.subcategory': 'Podkategorie',
  'label.title': 'Název',
  'label.username': 'Přihlašovací jméno',
  'label.what_is_your_role': 'Jaká je vaše role v organizaci?',
  'label.where_have_you_completed': 'Kde jste splnil?',
  'label.yes': 'Ano',
  'label.your_changes_havent_been_saved': 'Změny nebyly uloženy. Data budou ztracena.',
  'label.zip': 'PSČ',
  'label.adventurous_journey': 'Dobrodružná expedice',
  'label.after_your_journey_describe': 'V pár větách popište své pozorování z expedice.',
  'label.because_your_age_is_under_18': 'Jelikož ti není 18, potřebujeme souhlas tvého rodiče/opatrovníka',
  'label.before_you_head_to_journey': 'Předtím než můžeš pokračovat s ostrou expedicí, musíš nejdříve dokončit přípravu a trénink.',
  'label.before_entering_new_level': 'Před vstupem do nové úrovně potvrďte, že vaše údaje jsou stále aktuální',
  'label.bring_required_amount_to_your_award_leader': 'Přineste požadovanou částku vašemu vedoucímu nebo koordinátorovi na místním centru.',
  'label.do_you_have_any_other_level': 'Splnili jste již nějakou úroveň DofE?',
  'label.do_you_know_who_is_your_award_leader': 'Víte, kdo je váš vedoucí?',
  'label.going_on_an_expedition': 'Jít na expedici vám dává možnost zažít dobrodružství, pracovat v týmu a jednat na vlastní pěst.',
  'label.going_on_residential_gives_chance': 'Akce s pobytem poskytuje šanci naučit se pracovat s lidmi z různých prostředí a budovat důvěru v život v novém prostředí.',
  'label.i_confirm_that_i_meet': 'Potvrzuji, že splňuji všechny požadavky Národní kanceláře.',
  'label.i_agree_to_volunteer_code': "Souhlasím s dobrovolnickým kodexem chování. Pro více informací klikněte <a href='{url}' target='_blank'>zde</a>.",
  'label.i_have_read_the_terms_and_conditions': 'Přečetl jsem ustanovení a podmínky a souhlasím s nimi.',
  'label.i_will_bring_the_consent_to_my_award_leader_later': 'Přinesu souhlas svému vedoucímu',
  'label.if_you_are_from_orphanage': 'např.pokud vaše škola nebo organizace platí za vás.',
  'label.here_you_can_add_activity': 'Tady můžete přidat další přípravu a trénink',
  'label.how_do_you_want_to_apply': 'Jak se chcete přihlásit:',
  'label.my_parent_consent_has_been_already_given': 'Souhlas mého rodiče/opatrovníka už byl odevzdán vedoucímu',
  'label.my_parent_will_confirm_consent_by_email': 'Rodič/opatrovník potvrdí souhlas emailem.',
  'label.major_activity_means_that_you_have_to_spent': 'Nejdelší aktivita znamená, že se jí musíš věnovat dvojnásobek času v porovnání s ostatními aktivitami.',
  'label.not_sure_about_your_auth': 'Pokud si nejste jistý, k jakému místnímu centru se registrovat, kontaktuje Regionální kancelář.',
  'label.page_not_found': '404 - stránka nenalezena',
  'label.please_fill_in_the_following': 'Prosím vyplňte následující údaje pro autorizaci kontaktu/držitele licence v rámci vaší organizaci',
  'label.register_a_new_account_as': 'Registrovat nový účet jako',
  'label.residential_project': 'Akce s pobytem',
  'label.select_your_award_unit': 'Vyber své místní centrum',
  'label.the_expedition_can_be_faraway': 'Expedice může být tak daleko nebo tak blízko domova, jak jen chcete, a existují stovky způsobů, co na ní dělat.',
  'label.to_log_your_process_on_orb': 'Prosím, nastavte níže uvedené heslo pro dokončení vašeho účtu k ORB.',
  'label.waiting_for_assessment': 'Čeká na zhodnocení',
  'label.waiting_for_sign_off': 'Čekající na schválení vedoucím',
  'label.we_have_sent_you_an_email': 'Poslali jsme vám email s aktivačním kódem.',
  'label.what_level_of_the_award': 'Do jaké úrovně DofE jste registrováni?',
  'label.you_are_now_registering_as_participant': 'Nyní jste registrování jako účastník',
  'label.you_are_now_registering_as_award_unit': 'Nyní jste registrování jako Místní centrum',
  'label.you_can_use_my_photos_for_promotional_purposes': 'Jako účastník souhlasím s užíváním mých fotografií Mezinárodní nadací pro propagační účely',
  'label.you_can_send_activity_for_approval': 'Nyní můžete poslat aktivitu hodnotiteli ke schválení',
  'label.you_can_send_activity_for_leader': 'Nyní můžete poslat aktivit vedoucímu ke schválení',
  'label.you_can_send_residential_project_to_leader': 'Nyní můžete poslat akci s pobytem ke schválení vedoucímu.',
  'label.you_have_finished_now_send_to_approval': 'Aktivita je dokončena. Nyní je můžete odeslat hodnotiteůo ke schválení. Můžete také přidat osobní poznámku níže.',
  'label.preparation_and_training': 'Příprava a trénink',
  'label.you_will_be_redirected_to_the_payment': 'Budete přesměrováni na platební bránu, kde můžete platit kreditní nebo debetní kartou.',
  'label.you_will_be_the_first_award_leader': 'Budete prvním vedoucím ve vaší organizaci. Budete mít práva přidávat další vedoucí ceny, účastníky a spravovat DofE prostřednictvím Online Record Book.',
  'label.youll_receive_a_notification': 'Obdržíte notifikace, až váš vedoucí schválí vaši registraci. K ORB se můžete přihlásit <a>tady</a> (dokud vedoucí neschválí registraci, máte jen omezené možnosti).',
  'label.your_parent_email': 'Email vašeho rodiče/opatrovníka',
  'label.your_parent_first_name': 'Jméno vašeho rodiče/opatrovníka',
  'label.your_parent_last_name': 'Přijmení vašeho rodiče/opatrovníka',
  'label.your_report_approve_now_send_to_leader': 'Závěrečný report byla schválena hodnotitelem. Nyní ji můžes poslat vedoucímu ke schválení. Můžeš přidat i krátkou poznámku.',
  'label.there_are_loads_of_exciting_possibilities': 'Existuje spousta zajímavých možností a příležitostí. Vyberte něco, co vás bude naplňovat',
  'label.your_residential_project_has_been_setup': 'Akce s pobytem byla nastaven a odeslána vedoucímu ke schválení.',
  'label.your_report_has_been_sent_assessor': 'Report byl odeslán hodnotiteli ke schválení.',
  'label.your_report_has_been_sent_leader': 'Report byl odeslán vedoucímu ke schválení.',
  'label.your_residential_project_is_complete': 'Akce s pobytem je kompletní',
  'label.to_work_on_the_online': 'Pro práci ORB systému  se přihlaste k vašemu ORB účtu',
  'label.we_will_send_you_an_email': 'Pošleme vám email v momentě, kdy bude registrace k vašemu ORB účtu schválena.',
  'label.if_you_have_any_problems_or_doubts': 'V případě problémů se obraťte na vaše místní centrum.',
  'label.are_you_sure_you_want_to_leave': 'Chcete opravdu skončit? Data budou ztracena.',
  'label.no_logs_yet': 'Zatím žádné záznamy.<br />Zkus přidat první záznam kliknutím na "Přidat záznam" tlačítko.',
  'label.menu': 'Menu',
  'notifications.award_unit_has_been_created': 'Místní centrum bylo vytvořeno',
  'notifications.authorization_code_is_not_valid': 'Autorizační kód není platný',
  'notifications.email_has_been_confirmed': 'Emailová adresa byla potvrzena',
  'notifications.leader_has_been_created': 'Vedoucí byl vytvořen',
  'notifications.participant_has_been_created': 'Účastník byl vytvořen',
  'notifications.email_with_instructions_has_been_sent': 'Email s instrukcemi byl zaslán',
  'notifications.your_new_password_has_been_set': 'Nové heslo nastaveno',
  'notifications.success': 'Úspěch',
  'notifications.unknown_role': 'Neznámá role',
  'notifications.waiting_for_approval': 'Čeká na schválení',
  'notifications.activity_cannot_be_created': 'Aktivita nemůže být vytvořena dokud není schválená registrace',
  'notifications.new_activity_has_been_added': 'Nová aktivity přidána',
  'notifications.new_log_has_been_added': 'Nový záznam přidán',
  'notifications.log_has_been_deleted': 'Záznam smazán',
  'notifications.log_has_been_modified': 'Záznam změněn.',
  'notifications.adventurous_journey_cannot_be_created_until_approved': 'Expedice nemůže být vytvořena dokud není schválená registrace',
  'notifications.new_participant_event_has_been_added': 'Nový účastník přidán',
  'notifications.participant_event_has_been_completed': 'Účastníkova akce dokončena',
  'notifications.training_and_practice_modified': 'Trénink a příprava změněna',
  'notifications.completion_residential_project_completed': 'Akce s pobytem dokončena',
  'notifications.new_residential_project_has_been_added': 'Nová akce s pobytem přidána',
  'notifications.residential_project_cannot_be_created_until_approved': 'Akce s pobytem nemůže být vytvořena dokud není schválená registrace',
  'notifications.already_assessed_sent': 'Žádost o schválení vedoucím odeslána',
  'notifications.assessment_request_sent': 'Žádost o zhodnocení odeslána',
  'notifications.leader_approval_sent': 'Žádost o schválení vedoucím odeslána',
  'tabs.logs': 'Záznamy',
  'tabs.new': 'Nový',
  'tabs.overview': 'Přehled',
  'tabs.report': 'Report',
  'button.add_activity': 'Přidat aktivitu',
  'button.add_log': 'Přidat záznam',
  'button.continue_here': 'Pokračovat tady',
  'button.continue': 'Pokračovat',
  'button.continue_to_award': 'Pokračovat na DofE',
  'button.delete': 'Smazat',
  'button.edit': 'Upravit',
  'button.edit_log': 'Upravit záznam',
  'button.finish': 'Dokončit',
  'button.forgot_your_password': 'Zapomněli jste heslo?',
  'button.i_already_have_assessment': 'Už mám hodnocení',
  'button.leave_anyway': 'I tak opustit',
  'button.login': 'Přihlásit se',
  'button.no': 'Ne',
  'button.register': 'Registrovat',
  'button.send': 'Poslat',
  'button.send_for_approval': 'Poslat ke schválení',
  'button.setup': 'Nastavení',
  'button.setup_residential': 'Založit akci s pobytem',
  'button.stay': 'Zůstat',
  'button.submit': 'Odeslat',
  'button.update': 'Aktualizovat',
  'button.yes': 'Ano',
  'errors.at_least_num_characters': 'Nejméně {length}  znaků',
  'errors.do_not_match': 'Nesouhlasí',
  'errors.include_at_least_one_number': 'Obsahuje nejméně jednu číslici',
  'errors.include_both_lower_and_upper_case': 'Obsahuje nejméně jedno velké a malé písmeno',
  'errors.invalid_phone_format': 'Neplatné formát čísla',
  'errors.invalid_email_address': 'Neplatný email',
  'errors.required_field': 'Požadované pole',
  'errors.must_be_at_least': 'Musí být minimálně {min} znaků',
  'errors.must_be_no_more_than': 'Nesmí být více než {max} znaků',
  'errors.must_be_an_integer': 'Musí být číslo',
  'errors.must_contain_at_least': 'Musí obsahovat aspoň jedno číslo',
  'errors.must_include_at_least': 'Obsahuje nejméně jedno velké a malé písmeno',
  'errors.must_be_one_of': 'Musí být jedno z: {enums}',
  'errors.you_must_be_younger_than': 'Musíte být mladší než {years} let a {months} měsíců, abyste se zaregistrovali do DofE. Prosím, promluvte si o tom s s vaším místním centrem.',
  'errors.you_must_be_older_than': 'Musíte být starší než {years} let a {months} měsíců, než se zaregistrujete do DofE. Prosím, promluvte si o tom s s vaším místním centrem.',
  'errors.email_address_is_in_use_please_sign': 'E-mailová adresa je již používána, chcete-li se zaregistrovat na další úroveň, přihlaste se prosím k vašemu účtu.',
  'errors.email_address_is_in_use': 'Email je již používán',
  'errors.sorry_we_already_have_this_email': 'Omlouváme se, ale účet se zadaným emailem již existuje. Pokud chcete začít další úroveň <a href=\'/\'> přihlaste se ke svému účtu</a> a zvolte možnost "Začít další úroveň."',
  'wizard.authorising_contact': 'Autorizování kontaktu',
  'wizard.award_leader_contact': 'Kontakt vedoucího',
  'wizard.award_unit_details': 'Detail místního centra',
  'wizard.contact_details': 'Kontakt detail',
  'wizard.contacts': 'Kontakty',
  'wizard.level': 'Úroveň',
  'wizard.level_selection': 'Výběr úrovně',
  'wizard.leader_details': 'Detail vedoucího',
  'wizard.nominated_award_leader': 'Nominovaný vedoucí',
  'wizard.orb_account': 'ORB účet',
  'wizard.parent_consent': 'Souhlas rodiče',
  'wizard.participant_details': 'Detaily účastníka',
  'wizard.profile': 'Profil',
  'wizard.payment': 'Platba',
  'wizard.select_award_unit': 'Zvolit místní centrum',
  'wizard.unit_details': 'Detaily místního centra',
  'wizard.welcome': 'Vítejte',
  'wizard.your_details': 'Vaše detaily',
  'awardUnit.do_you_want_to_create': 'Chcete vytvořit nové místní centrum?',
  'parent.you_can_download_the_consent_here': ' Pokud jej ještě nemáte, formulář pro souhlas rodičů si můžete stáhnout zde.  Podepsaný vaším rodičem/opatrovníkem odevzdejte svému vedoucímu.',
  'footer.copyright': "&copy; Copyright The Duke of Edinburgh's International Award 2017",
  'registration_participant.required_award_payment': 'Je požadována platba',
  'registration_participant.pay_online_here': 'Zaplaťte online a získejte vaše ID transakce tady',
  'dashboard.activity_log_time': '{hours}h {minutes}min',
  'moduleTitle.award_completed': 'Úroveň splněna!',
  'notifications.award_approval_request_sent_to_leader': 'Žádost o schválení úrovně odeslána vedoucímu',
  'notifications.new_participant_event_has_been_completed': 'Nová akce účastníka dokončena',
  'notifications.preparation_and_training_approval_sent': 'Schválení přípravy a tréninku odesláno',
  'notifications.reparation_and_training_completed': 'Příprava a trénink dokončena',
  'notifications.your_profile_photo_has_been_edited': 'Profilová fotka byla upravena',
  'notifications.your_profile_has_been_edited': 'Profil byl upraven',
  'notifications.new_level_has_started': 'Další úroveň začala',
  'notifications.activity_has_been_edited': 'Aktivita byla upravena',
  'notifications.you_have_been_logged_out': 'Odhlašování...',
  'notifications.logging_out': 'Byl jste odhlášen',
  'label.you_can_send_award_to_leader': 'Můžete odeslat žádost o schválení úrovně svému vedoucímu.',
  'label.you_have_completed_all_sections_of_your_award': 'Dokončili jste všechny aktivity své úrovně Nyní ji můžete odevzdat vedoucímu ke schválení. Můžete také přidat osobní poznámku níže.',
  'label.you_have_now_completed_your_award': 'Splnili jste {level} úroveň. Chcete začít další úroveň?',
  'label.congratulation_your_award_has_been_approved': 'Gratulujeme. Vaše {level} úroveň byla schválena!  <br /> Pokud chceš, můžeš začít další úroveň.',
  'moduleTitle.settings': 'Nastavení',
  'moduleTitle.edit_activity': 'Upravit aktivitu',
  'moduleTitle.select_your_major_activity': 'Vyberte nejdelší aktivitu',
  'label.settings': 'Nastavení',
  'label.major_activity_means_that_you_will': 'Nejdelší aktivita znamená, že se této aktivitě budete muset věnovat delší dobu ve srovnání s ostatními aktivitami. Pro zlato a stříbro je nutný dodatečný čas šest měsíců, u bronze jsou to tři měsíce.',
  'label.notifications': 'Notifikace',
  'label.my_award': 'Má úroveň',
  'label.physical_recreation': 'Sport',
  'label.skill': 'Rozvoj talentu',
  'label.service': 'Dobrovolnictví',
  'label.my_parent_will_complete_and_sign_form': 'Můj rodič / opatrovník vyplní a podepíše formulář pro souhlas rodiče/opatrovníka',
  'label.please_print_it_tak_it_to_your_parent': 'Prosím vytiskni, nech podepsat rodičem/opatrovníkem a odevzdej svému vedoucímu',
  'label.change_password': 'Změnit heslo',
  'label.change_major_activity': 'Změnit nejdelší aktivitu',
  'title.change_password': 'Změnit heslo',
  'label.old_again': 'Staré heslo',
  'label.new_password': 'Nové heslo',
  'label.new_password_again': 'Nové heslo znovu',
  'errors.passwords_dont_match': 'Hesla se neshodují',
  'errors.more_than': 'Více než {limit}',
  'button.parent_guardian_consent_pdf': 'Souhlas rodiče/opatrovníka.pdf',
  'button.send_award_for_approval': 'Poslat úroveň ke schválení',
  'button.send_report': 'Poslat report',
  'button.terms_and_conditions': 'Mezinárodní ustanovení & podmínky',
  'button.privacy_policy': 'Zásady ochrany osobních údajů',
  'button.save': 'Uložit',
  'button.start_new_level': 'Začít další úroveň',
  'button.change_password': 'Změnit heslo',
  'button.edit_activity': 'Upravit aktivitu',
  'moduleTitle.file_upload': 'Nahrát soubor',
  'label.add_file': 'Přidat soubor',
  'label.description': 'Popis',
  'label.waiting_for_office_sign_off': 'Čekající na schválení kanceláří',
  'notifications.file_has_been_uploaded': 'Soubor byl nahrán',
  'tabs.files': 'Soubory',
  'button.upload': 'Nahrát',
  'button.upload_file': 'Nahrát soubor',
  'button.add_file': 'Přidat soubor',
  'button.this_activity_has_no_assessor': 'Tato aktivita nemá hodnotitele. Musíš nastavit údaje hodnotitele před odesláním ke schválení',
  'label.i_want_to_register_my_award': 'Chci zaregistrovat místní centrum jako nezávislé mistní centrum',
  'label.select_sub_operating_authority': 'Vybrat pobočku',
  'label.your_must_first_setup_some_activity': 'Nejdřív musí být nastavena jakákoliv aktivita',
  'label.you_cant_change_your_major_activity': 'Nemůžete změnit nejdelší aktivitu, protože už byla dokončena',
  'label.s_specific': 'S- Specifický: Cíl by neměl být příliš široký. Místo "Chci se zlepšit ve hře na housle" by cíl mohl být např. "Chci zvládat F stupnici ve hře na housle"',
  'label.m_measurable': 'M-Měřitelný: Mělo by být zřetelné, kdy jste dokončili svůj úkol a jak to změřit. Místo "Chci pomáhat komunitě" by cíl měl být "Chci pomáhat lidem v komunitní kuchyni vařící pro pro bezdomovce tím, že jim zde budu dobrovolně pomáhat jednou týdně". Cíl tak může být v tomto případě měřen.',
  'label.a_achievable': 'A - Dosažitelný (achievable): Cíl by měl být dosažitelný v rámci času, který máš na splnění dané úrovně. Místo "Chci vyřešit chudobu", je lepší stanovit praktičtější cíl jako "Chci získat peníze, abych je mohl poslat do vesnice v zemi třetího světa a pomoct v boji proti chudobě"',
  'label.r_realistic': 'R- Realistický: Prakticky stejné jako v případě dosažitelnosti. Mohu cíle dosáhnout v požadovaném čase?',
  'label.t_timely': 'T- Ohraničený v čase (time bound): Cíl by měl obsahovat časový rámec, kdy bych chtěl mít cíl splněn. Např. "Chci zvládat F stupnici při hře na housle do 3 měsíců."',
  'label.you_can_upload_here_any_files': 'Tady můžete nahrát jakékoliv soubory, které chcete sdílet se svým vedoucím',
  'moduleTitle.login_change': 'Přihlašovací jméno změněno',
  'notifications.adventurous_journey_modified': 'Expedice byla změněna',
  'tabs.sections': 'Sekce',
  'label.change_email': 'Změnit email',
  'title.change_email': 'Změnit email',
  'label.new_email': 'Nový email',
  'label.new_email_again': 'Potvrdit nový email',
  'errors.emails_dont_match': 'Emaily se neshodují',
  'button.change_email': 'Změnit email',
  'notifications.email_with_instructions_has_been_sent_to_your_inbox': 'Email s instrukcemi byl zaslán na vaší adresu',
  'global.dofe_name': 'Mezinárodní cena vévody z Edinburghu',
  'global.or': 'nebo',
  'route.landing_page': 'Landing stránka',
  'route.dashboard': 'Deska',
  'moduleTitle.notifications': 'Notifikace',
  'moduleTitle.no_notifications': 'Žádní notifikace',
  'moduleTitle.new_notifications': 'Nové notifikace',
  'moduleTitle.older_notifications': 'Starší notifikace',
  'moduleTitle.user_guide': 'Návody',
  'label.user_guide': 'Návody',
  'notifications.your_password_has_been_changed': 'Heslo bylo změněno',
  'label.country': 'Země',
  'label.on_your_smartphone': 'Na tvém smartphonu',
  'label.on_the_web': 'Na webu',
  'label.orb_online': 'ORB online',
  'label.language': 'Jazyk',
  'moduleTitle.participant_login': 'Přihlášení účastníka',
  'label.for_ios': 'pro iOS',
  'label.for_android': 'pro Android',
  'button.login_as_award_staff': 'Přihlásit se jako zaměstnanec',
  'errors.leader_doesnt_exist': 'Vedoucí neexistuje',
  'global.loading': 'Načítání',
  'moduleTitle.award_staff_login': 'přihlášení pro zaměstnance',
  'formTitle.residential_project_details': 'Detaily akce s pobytem',
  'label.you_can_also_download_participant': 'Můžete si také stáhnout naši zbrusu novou <strong>aplikaci pro účastníka</strong> a budete mít k ORB přístup kdykoliv a kdekoliv.',
  'label.you_can_also_download_leader': 'Můžete si také stáhnout naši zbrusu novou <strong>aplikaci pro vedoucí</strong> a budete mít k ORB přístup kdykoliv a kdekoliv.',
  'notifications.this_role_is_not': 'Tato role momentálně není podporována',
  'notifications.residential_project_has_been_updated': 'Akce s pobytem byla aktualizována',
  'tabs.participant': 'Účastník',
  'tabs.award_staff': 'Zaměstnanci',
  'moduleTitle.edit_residential_project': 'Editovat akci s pobytem',
  'button.residential_project': 'Editovat akci s pobytem',
  'notifications.your_login_email_has_been_changed': 'Váš email byl změněn',
  'meta.dofe_name': 'Mezinárodní cena vévody z Edinburghu',
  'notifications.unknown_role_leader': 'Neznámá role - Použít zaměstnanecký login',
  'notifications.unknown_role_participant': 'Neznámá role - Použít účastníkův login',
  'label.user_guide_web_participant': 'Návod k app - účastník',
  'label.user_guide_app_participant': 'Návod k app - účastník',
  'label.note_for_supervisor': 'Poznámka pro školitele',
  'label.before_submitting_your_aj': 'Před odesláním expedice vedoucímu potřebujete nejdříve schválení od vašeho {role}. Můžete také přidat poznámku.',
  'button.back_to_home': 'Zpátky domů',
  'moduleTitle.assessor_approval': '\n {role} Schválení',
  'label.this_aj_has_no_assessor': 'Tato expedice nemá žádné {role}. Aktualizujte je předtím než expedici odešlete ke schválení.',
  'route.not_found': 'Nenalezeno',
  'notifications.are_you_sure': 'Jste si jistí?',
  'button.cancel': 'Zrušit',
  'label.add_document': 'Přidat dokument',
  'errors.there_are_currently_no_details_for_your': 'Momentálně nejsou žádné detaily o vaší {role}. Prosím vyplňte chybějící údaje před odevzdáním vaší aktivity ke zhodnocení.',
  'moduleTitle.missing_data': 'Chybějící data',
  'label.to_send_assessment_request': 'Pokud chcete zaslat žádost o hodnocení elektronicky, prosím vyplňte {role} email.',
  'label.pending_changes': 'Čekající změny',
  'label.some_fields_require': 'Některá políčka vyžadují tvou pozornost',
  'roles.assessor': 'Hodnotitel',
  'roles.supervisor': 'školitel',
  'pageTitle.register_participant': 'Registrovat účastníka',
  'moduleTitle.revise_message': 'Opravit zprávu',
  'moduleTitle.payment_for_level': 'Platba za {awardLevel}',
  'moduleTitle.payment': 'Platba za registraci účastníka',
  'moduleTitle.we_have_sent_you_payment_link': 'Poslali jsme vám email s odkazem na platební membránu',
  'label.required_award_payment': 'Vyžadována platba za DofE',
  'label.payment_fees': 'Poplatek za platbu',
  'label.payment_method': 'Platební metoda',
  'label.you_will_type_trans_id': 'Budete vyžádáni zadat ID vaší transakce',
  'label.any_level_previously': 'Jakákoliv úroveň splněna',
  'label.registering_for_level': 'Registrace k úrovni',
  'notification.payment_link_expired': 'Platební odkaz vypršel',
  'button.pay': 'Platit',
  'label.registration_updated': 'Registrace byla aktualizována.',
  'label.award_leader_receive_payment': 'Vedoucí obdrží informace o platbě',
  'errors.end_date_after': 'Datum konce musí být po datu začátku',
  'button.back': 'Zpět',
  'button.edit_info': 'Úpravy info',
  'moduleTitle.level_detail': 'Detail úrovně',
  'label.payment_methods': 'Platební metody',
  'label.address': 'Adresa',
  'note.review_filled_participant': 'Prosím zkontrolujte údaje zadány účastníkem. Opravte je v případě chyb.',
  'moduleTitle.payment_successful': 'Platba za registraci účastníka úspěšná',
  'button.proceed_to_login': 'Pokračovat na přihlášení',
  'label.add_additional_activity': 'Přidat další aktivitu',
  'moduleTitle.welcome_to_orb': 'Vítejte v ORB',
  'empty_dashboard.not_approved': 'Tento nástroj vám pomůže zaznamenat váš pokrok během tvého DofE. Tvůj profil však ještě není schválen vedoucím. Než začneš se svou první aktivitu, budeš muset počkat na schválení.',
  'empty_dashboard.approved_1': 'Tento nástroj vám pomůže zaznamenat váš pokrok během tvého DofE.',
  'empty_dashboard.approved_2': 'Nejprve musíte nastavit svou aktivitu. Chcete-li začít, klikněte na jednu vlevo. Pokud potřebujete pomoc s nastavením činnosti, požádejte o pomoc svého vedoucího.',
  'label.discuss_activity_leader': 'Pokud vybíráte více než jednu aktivitu, proberte to nejdříve s vedoucím.',
  'label.cannot_add_activity': 'Pro tuto kategorii můžete přidat maximálně 3 aktivity. Prober to prosím s tvým vedoucím.',
  'button.ok': 'OK',
  'label.payment_was_canceled': 'Platby byla zrušena uživatelem',
  'label.problem_with_payment': 'Při zpracování platby došlo k potížím. Obraťte se prosím na Národní kancelář DofE.',
  'pageTitle.register_leader': 'Registrace vedoucího',
  'pageTitle.registration_complete': 'Registrace dokončena',
  'label.payment_link_expired_or_paid': 'Poplatek za registraci již zaplacen nebo platnost platebního odkazu vypršela.',
  'label.contact_nao_assistance': 'Pokud potřebuješ pomoc, kontaktuj své místní centrum',
  'label.send_required_amount_to_your_award_leader': 'Pošli požadovanou částku svému vedoucímu nebo koordinátorovi DofE ve vašem místním centru.',
  'label.fee_can_be_paid': 'Poplatek může být placen online pomocí karty VISA, Master Card nebo kreditní debetní karty.',
  'notifications.login_failed_right_tab': 'Přihlášení neúspěšné. Ujistěte se, že jste na správné kartě (Účastník / Zaměstnanec)',
  'label.i_have_read_privacy_policy': 'Přečetl jsem si Pravidla ochrany osobních údajů a souhlasím s nimi.',
  'errors.invalid_date_format': 'Nesprávný formát data',
  'label.no_privacy_policy': 'Nebyly nalezeny žádné zásady ochrany osobních údajů. Můžete bezpečně pokračovat kliknutím na tlačítko dokončit',
  'label.status': 'Status',
  'moduleTitle.attached_with_observation': 'Přiloženo s pozorováním',
  'moduleTitle.revise_message_rp': 'Akce s pobytem byla revidována vedoucím',
  'file.activity_section_summary': '{section}-oblast-souhrn',
  'label.download_section_summary': 'Stáhnout souhrn oblasti',
  'label.award_summary': 'Souhrn úrovně',
  'btn.download_summary_for_assessor': 'Stáhnout souhrn pro hodnotitele',
  'label.first_activity_started': 'První aktivity započata',
  'label.hours_completed_required': 'Hodiny dokončeny/vyžadovány',
  'label.weeks_completed_required': 'Týdny dokončeny/vyžadovány',
  back_to_home: 'Zpátky domů',
  'label.activity_rejected_click': 'Aktivita byla odmítnuta vedoucím.Klikni pro',
  'button.more_information': 'více informací',
  'label.attached_file': 'Přiložený soubor',
  'moduleTitle.journey_details': 'Detail expedice',
  'tabs.activity': 'Aktivita',
  'label.confirm_email': 'Potvrdit email',
  'label.aj_rejected_click': 'Tvá expedice byla zamítnuta vedoucím. Klikni pro',
  'label.verifying_payment': 'Ověřování platby',
  'button.finish_and_pay': 'Dokončit a zaplatit',
  'label.payment_not_successful_text': 'Jelikož jsi ještě nezaplatil za DofE, je potřeba tak učinit nyní.',
  'label.payment_not_completed': 'Platba nedokončena',
  'button.pay_now': 'Zaplatit teď',
  'label.registration_pending_parental_consent': 'Registrace čeká na schválení (souhlas rodiče)',
  'button.edit_observation': 'Upravit pozorování',
  'moduleTitle.qualifying': 'Ostrá expedice',
  'moduleTitle.practice': 'Cvičná',
  'label.first_log_entry': 'První záznam',
  'label.first_log_entry_date': 'Datum prvního záznamu',
  'label.last_log_entry': 'Poslední záznam',
  'label.last_log_entry_date': 'Datum posledního záznamu',
  'label.you_can_send_journey_report_for_approval': 'Můžete poslat závěrečnou zprávu  {journey} expedice na schválení.',
  'button.edit_and_resend_report': 'Uprav report a znovu jej odešli',
  'label.your_journey_is_complete': 'Tvá {journeyType} expedice dokončena',
  'button.add_additional_journey': 'Přidat další expedici',
  'moduleTitle.edit_journey': 'Upravit expedici',
  'notifications.assessment_sent': 'Zhodnocení bylo odesláno',
  'notifications.file_is_too_big': 'Soubor nelze nahrát. Nejspíše je příliš velký.',
  'notifications.authorization_code_has_expired': 'Autorizační kód expiroval, prosím, požádejte o nový kód.',
  'route.confirm_email': 'Potvrďte E-mail',
  'label.assessor_needs_account': 'Abyste mohli pracovat v Online Record Book, potřebujete osobní ORB účet. Prosím, vytvořte si ho zde.',
  'label.company_name': 'Název firmy',
  'label.secondary_email_again': 'Potvrďte druhý e-mail',
  'label.how_many_years': 'Kolik let/měsíců?',
  'label.no_company_leave_empty': 'Pokud nepracujete pro žádnou firmu, nechte toto pole prázdné',
  'label.secondary_phone_number': 'Alternativní telefonní číslo',
  'label.secondary_phone_type': 'Typ alternativního telefonu',
  'label.wwc_application_number': '',
  'label.wwc_expiration_date': '',
  'label.you_are_now_registering_as_assessor': 'Nyní se registrujete jako hodnotitel.',
  'label.you_have_finished_aj_now_send_to_approval': 'Vaše dobrodružná expedice je ukončena. Nyní ji můžete odeslat Vašemu hodnotiteli ke schválení. Můžete také přidat poznámku. ',
  'label.your_experience': 'Vaše zkušenosti',
  'label.your_qualification': 'Vaše kvalifikace',
  'notifications.waiting_for_assessor_approval': 'Čeká na schválení hodnotitele',
  'button.resend_assessment_request': 'Poslat znovu žádost o hodnocení',
  'errors.emails_must_be_different': 'Alternativní e-mail musí být odlišný od primárního.',
  'moduleTitle.company_details': 'Údaje o společnosti',
  'notifications.already_resent_assessment_request': 'Žádost o hodnocení již byla znovu odeslána. ',
  'route.assessor_dashboard': '',
  'pageTitle.register_assessor': 'registrovat hodnotitele',
  'wizard.assessor_details': 'Informace o hodnotiteli',
  'wizard.assessor_experience': 'Zkušenosti hodnotitele',
  'wizard.personal_details': 'Osobní údaje',
  'button.sign_off': 'Odhlásit se',
  'button.sign_off_dashed': 'Odhlásit se',
  'moduleTitle.sign_off': 'Odhlásit se',
  'label.certify_participant_met_reqs': 'Jako hodnotitel potvrzuji, že účastník splnil všechny podmínky.',
  'label.assessor_report': 'Zpráva hodnotitele',
  'label.content_update': 'Prosím čekejte. Nahrávám obsah.',
  'label.comment_on_participant_improvement': 'Prosím zhodnoťe k jakému pokroku a zlepšení došlo u účastníka, případně jak svědomitě plnil aktivitu. ',
  'note.edit_participant_review': '',
  'errors.min_age': 'Minimální věk je {age}',
  'notifications.assessor_link_expired': 'Odkaz hodnotitele již není platný',
  'label.secondary_email': 'Další e-mail',
  'moduleTitle.review_participant_info': '',
  'label.loading_payment_gateway': '',
  'label.consent_given_login_as_child': '',
  'notifications.only_one_qualification_journey_per_award': '',
  'label.registration_fees_participant': '',
  'moduleTitle.leader_details': 'Detail vedoucího',
  'label.leader_name': 'Jméno vedoucího',
  'label.leader_phone': 'telefon vedoucího',
  'label.leader_email': 'email vedoucího',
  'moduleTitle.au_details': 'Detail místního centra',
  'label.au_name': 'Název místního centra',
  'label.assessor_guidelines': 'Zásady',
  'label.assessor_cond_req': 'Podmínky a požadavky',
  'label.assessor_ref_handbook': '',
  'label.assessor_ref_online_modules': '',
  'label.participant_has_no_aj_report': '',
  'moduleTitle.participant_details': 'Údaje o účasníkovi',
  'label.participants_has_no_logs': 'Účastník zatím nepřidal žádný příspěvek',
  'label.location_type': '',
  'label.activity_ready_for_signoff': '',
  'label.activities': 'Aktivity',
  'label.choose_how_you_want_to_login': 'Vyberte, jak se chcete přihlásit',
  'roles.leader': 'Vedoucí',
  'roles.award_verifier': '',
  'roles.coordinator': 'Koordinátor',
  'roles.aj_assessor': 'Hodnotitel dobrodružné expedice',
  'roles.aj_supervisor': 'Školitel dobrodružné expedice',
  'roles.instructor': 'Instruktor',
  'roles.nao_staff': 'Zaměstnanec národní kanceláře',
  'roles.super_user': '',
  'roles.user': 'Uživatel',
  'roles.viewer': '',
  'roles.authorizing_contact': 'Autorizující kontakt',
  'roles.if_staff_superuser': '',
  'roles.if_staff_statistical_user': '',
  'roles.if_staff_viewer': '',
  'roles.aj_instructor': 'Instruktor dobrodružné expedice',
  'label.if_you_have_questions_au': 'V případě jakýchkoli dotazů ohledně registrace, prosím, kontaktujte Vaše místní centrum.',
  'label.we_will_send_you_an_email_leader': 'Jakmile bude registrace Vaše ORB účtu schválena, budete informováni e-mailem. ',
  'moduleTitle.rejecting_assessor_invitation': '',
  'notifications.assessor_invitation_rejected': '',
  'moduleTitle.participants_list_is_empty': 'Seznam účastníků je prázdný',
  'label.note_from_participant': 'Zpráva od účastníka',
  'label.you_can_send_aj_to_leader': 'Nyní můžeš poslat svou dobrodružnou expedici na schválení vedoucímu. ',
  'button.save_report': 'Uložit report',
  'label.this_activity_has_no_assessor': 'Tato aktivita nemá přiřazeného hodnotitele. Předtím, než odešleš žádost o schválení aktivity, je třeba vyplnit detaily hodnotitele. ',
  'label.activity_rejected_click_by_assessor': '',
  'button.reject': 'Odmítnout\n',
  'button.reject_invitation': 'Odmítnout pozvánku',
  'label.reason': 'Důvod',
  'label.accept_invitation_and_continue': 'Přijmout pozvání a pokračovat',
  'pageTitle.registration_reject': 'Registrace odmítnuta',
  'errors.you_must_be_older_than_register_for_leader': 'Musíte být starší {years} let and {months} měsíců, abyste se mohl/a registrovat jako vedoucí DofE. ',
  'label.your_report_approve_now_send_to_leader_without_note': '',
  'button.stop_assessing_this_activity': '',
  'button.confirm': 'Potvrdit',
  'moduleTitle.are_you_sure': 'Jste si jistý',
  'label.content_restore': '',
  'button.stop_editing': '',
  'notifications.activity_has_been_rejected': 'Aktivita byla zamítnuta',
  'notifications.aj_has_been_rejected': 'Dobrodružná expedice byla zamítnuta',
  'notifications.rp_has_been_rejected': 'Zlatá akce s pobytem byla zamítnuta',
  'moduleTitle.additional_files': 'Další dokumenty',
  'moduleTitle.no_additional_files': 'Další dokumenty',
  'moduleTitle.stop_assessing_section': '',
  'label.show_security_and_refund_policy': '',
  'moduleTitle.security_and_refund_policy': '',
  'label.fees_payment': '',
  'label.redund_policy': '',
  'label.security_policy': '',
  'label.leave_blank': '',
  'label.frequently_asked_questions': 'Často kladené otázky (FAQs)',
  'label.language_selection_is_disabled_for_iac': '',
  'errors.min_nights_required': 'Minimální počet noví je požadován',
  'label.completion_date': 'Datum dokončení',
  'label.you_are_offline': 'Jste offline. Změny nemusí být uloženy. ',
  'errors.start_date_after_award_start': 'Datum ukončení nesmí být dříve než datum zahájení. ',
  'label.participants': 'Účastníci',
  'label.marketing_from_iaf': '',
  'label.marketing_from_oa': '',
  'label.marketing_from_nao': '',
  'label.select_iac': '',
  'label.you_will_be_redirected_to_the_paypal_payment': '',
  'notifications.report_has_been_sent': 'Report byl odeslán',
  'label.processing_paypal_payment': 'Zpracovávání platby PayPal',
  'label.loading_paypal_gateway': 'Nahrávání platební brány PayPal',
  'label.payment_failed': 'Platba se nezdařila',
  'label.payment_has_been_cancelled': 'Platba byla zrušena nebo se nezdařila',
  'roles.naa_oa_staff': 'Zaměstnanci Národní kanceláře',
  'label.download_report_and_upload_signed_version': '',
  'button.download_summary_for_assessor': 'Stáhnout souhrn pro hodnotitele',
  'label.pay_online_mastercard': 'Platit online',
  'label.pay_online_paypal': 'Platit online',
  'notifications.authorization_code_is_missing': 'Chybí autorizační kód',
  'errors.unknown_payment_error': 'Během platby se vyskytla neznámá chyba',
  'errors.already_in_use_by_auth_contact': '',
  'roles.if_staff_stat_user': '',
  'moduleTitle.you_have_been_logged_out_due_to_inactivity': '',
  'announcement.survey_description.do_think_people_are_lazy': '',
  'announcement.survey_title.join_our_global_survey': '',
  'announcement.survey_button.if_below_25': 'Pokud jsi 16-25 let',
  'announcement.survey_button.if_over_25': 'Pokud je ti více než 25 let',
  'moduleTitle.privacy_and_cookie_policy': '',
  'label.we_have_made_some_important_changes': '',
  'button.i_agree': 'Souhlasím',
  'button.see_more_details': 'Více informací',
  'label.the_cookie_settings_on_this': '',
  'label.after_your_rp_describe': '',
  'label.you_are_going_to_be_logged_out': ''
}
